import { InputGroup } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";

import { MultiSelect } from "../multi-select";
import { UseTableFilters } from "../play-table/hooks";
import styles from "./play-table-filters.module.scss";

export const PlayTableFilters = ({
  playNameFilter,
  onPlayNameFilterChange,
  seasonMultiSelect,
  teamsMultiSelect,
  seriesMultiSelect,
  tagsMultiSelect,
}: UseTableFilters) => {
  return (
    <div className={styles.container}>
      <div className={styles.advancedFiltersContainer}>
        <MultiSelect {...seasonMultiSelect} className={styles.filter} placeholder="Seasons" />
        <MultiSelect {...teamsMultiSelect} className={styles.filter} placeholder="Teams" />
        <MultiSelect {...seriesMultiSelect} className={styles.filter} placeholder="Series" />
        <MultiSelect {...tagsMultiSelect} className={styles.filter} placeholder="Tags" />
        <InputGroup
          className={classNames(styles.searchFilter)}
          value={playNameFilter}
          onChange={onPlayNameFilterChange}
          placeholder="Play Name"
        />
      </div>
    </div>
  );
};
